<template>
  <div class="file-upload">
    <label
      class="uploadImgBtn customBtn"
      :class="{ upload: uploadStatus, icon_only: icon_only }"
      :style="{
        backgroundSize: uploadProgress + '%',
        width: (width || size) + 'px',
        height: (round ? size : size || height) + 'px',
        padding: padding ? padding + 'px !important' : '',
        borderRadius: borderRadius ? borderRadius + 'px !important' : '',
      }"
    >
      <UploadImgIcon />
      <span class="load f14 fw500" :class="{ grid: format }"
        >{{ text }} <span class="format">{{ format }}</span></span
      >
      <input
        class="fileInput"
        type="file"
        :accept="fileAccept"
        v-on:change="handleFileUpload"
        :multiple="multiple"
      />
    </label>
  </div>
</template>

<script>
import UploadImgIcon from 'components/icons/personalArea/UploadImgIcon'
import { mapGetters } from 'vuex'
export default {
  name: 'ButtonFileUpload',
  props: [
    'text',
    'click',
    'disabled',
    'rules',
    'fileAccept',
    'uploadStatus',
    'multiple',
    'format',
    'icon_only',
    'width',
    'height',
    'padding',
    'borderRadius',
    'round',
    'size',
  ],
  components: { UploadImgIcon },
  data() {
    return {
      files: null,
    }
  },
  computed: {
    ...mapGetters(['uploadProgress']),
  },
  methods: {
    async handleFileUpload(e) {
      console.log(e)
      this.files = e.target.files
      this.$emit('buttonFileUpload', {
        files: this.files,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.uploadImgBtn:deep() {
  .load {
    color: #ffffff;
    &.grid {
      display: grid;
      grid-template-columns: auto auto;
      column-gap: 10px;
    }
    .format {
      color: #b4b4b4;
      font-weight: 400;
    }
  }
  &.upload {
    pointer-events: none;
  }

  .fileInput {
    display: none;
  }
}
</style>
